import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
  const token = localStorage.getItem("token");
  return openSocket(getBackendUrl(), {
    // forceNew: cada chamada abre uma conexão PRÓPRIA. Sem isto, socket.io-client
    // multiplexa/reusa a mesma conexão para a mesma URL, então vários componentes
    // (lista, MessagesList, sidebar) compartilham 1 socket — e o socket.disconnect()
    // no cleanup de um derruba o de todos, gerando churn de reconexão que impede o
    // joinChatBox de "grudar" (mensagens não aparecem ao vivo; só no F5).
    forceNew: true,
    // websocket-first: com forceNew, cada componente abre uma conexão própria.
    // Polling (HTTP long-poll) esbarraria no limite de ~6 conexões por host do
    // browser e o socket do MessagesList (aberto por último) não conectaria.
    // WebSocket não tem esse limite e passa pelo proxy (Traefik) — testado.
    transports: ["websocket", "polling"],
    query: {
      token: JSON.parse(token),
    },
  });
}

export default connectToSocket;
